export enum SalesVoucherTypeEnum {
  NORMAL_VOUCHER = '1', //通常伝票
  ADJUST_TAX_VOUCHER = '2', // 消費税調整伝票
}

export const SalesVoucherType = [
  { label: '通常伝票', value: SalesVoucherTypeEnum.NORMAL_VOUCHER },
  { label: '消費税調整伝票', value: SalesVoucherTypeEnum.ADJUST_TAX_VOUCHER },
];
